import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/lib/brand";
import ThemeToggle from "@/components/ThemeToggle";

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-paper/85 backdrop-blur-md border-b hairline" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link" onClick={() => setOpen(false)}>
            <img src={LOGO_URL} alt="Reliserve Wealth" className="h-16 w-auto md:h-[68px]" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-[14px] tracking-wide transition-colors ${
                    isActive
                      ? "text-brass-deep font-medium"
                      : "text-ink-soft hover:text-ink"
                  }`
                }
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <ThemeToggle testId="theme-toggle-desktop" />
            <a
              href="https://reliservepulse.com/book-consultation"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brass"
              data-testid="header-cta-talk"
            >
              Talk to us
            </a>
          </div>

          <div className="lg:hidden flex items-center gap-2">
            <ThemeToggle testId="theme-toggle-mobile" />
            <button
              className="text-ink p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "Close menu" : "Open menu"}
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t hairline" data-testid="mobile-nav">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `py-3 px-2 text-[15px] ${isActive ? "text-brass-deep font-medium" : "text-ink-soft"}`
                  }
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {link.label}
                </NavLink>
              ))}
              <a
                href="https://reliservepulse.com/book-consultation"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-brass mt-4 justify-center"
                onClick={() => setOpen(false)}
                data-testid="mobile-cta-talk"
              >
                Talk to us
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
